export const OrdersActionTypes = {
    API_RESPONSE_SUCCESS: '@@orders/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@orders/API_RESPONSE_ERROR',
    GET_ALL_ORDERS: '@@orders/GET_ALL_ORDERS',
    GET_ALL_ORDERS_REPORT: '@@orders/GET_ALL_ORDERS_REPORT',
    CREATE_LABEL_FOR_ORDER: '@@orders/CREATE_LABEL_FOR_ORDER',
    REQUEST_ORDER_REFUND: '@@orders/REQUEST_ORDER_REFUND',
    RESET_STATE: '@@orders/RESET_STATE',
    RESET_ALL_ERRORS: '@@orders/RESET_ALL_ERRORS',
};
